
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AccountResearchInfo, AccountResearchTsmCharts, AlertSignUpInfo, ExecutionResult, GridMetadata, KeyValue, TsmAccountResearchInfoCriteria, TsmReportCriteria, TsmTokenParam, TylerSmartMeterNotificationInfo } from "@tylertech/tyler-api-types";

/**
 * TylerSmartMeterService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class TylerSmartMeterService {
    private readonly $apiService = inject(ApiService);
    
    GetAccountClass(): Promise<KeyValue[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountClass");
    }
    GetAccountResearchInfo(input: TylerSmartMeterNotificationInfo): Promise<AccountResearchInfo> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfo", input);
    }
    GetAccountResearchInfoAlerts(input: TylerSmartMeterNotificationInfo): Promise<any[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoAlerts", input);
    }
    GetAccountResearchInfoBySearchCriteria(input: TsmAccountResearchInfoCriteria): Promise<AccountResearchInfo> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoBySearchCriteria", input);
    }
    GetAccountResearchInfoCharts(input: TylerSmartMeterNotificationInfo): Promise<AccountResearchTsmCharts> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoCharts", input);
    }
    GetAccountResearchInfoServiceOrderHistory(input: TylerSmartMeterNotificationInfo): Promise<any[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoServiceOrderHistory", input);
    }
    GetAccountResearchInfoTransactionHistory(input: TylerSmartMeterNotificationInfo): Promise<any[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoTransactionHistory", input);
    }
    GetAccountResearchInfoTsmAlerts(input: TylerSmartMeterNotificationInfo): Promise<any[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoTsmAlerts", input);
    }
    GetAccountResearchInfoTsmAlertsHistories(input: TylerSmartMeterNotificationInfo): Promise<any[]> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAccountResearchInfoTsmAlertsHistories", input);
    }
    GetAlertSignUpInfo(): Promise<AlertSignUpInfo> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetAlertSignUpInfo");
    }
    GetExportCsv(input: TsmReportCriteria): Promise<string> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetExportCsv", input);
    }
    GetSmartMeterReportMetadata(reportType: string): Promise<GridMetadata> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetSmartMeterReportMetadata", reportType);
    }
    GetToken(tokenParams: TsmTokenParam): Promise<string> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/GetToken", tokenParams);
    }
    SendNotification(input: TylerSmartMeterNotificationInfo): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("ITylerSmartMeterService/SendNotification", input);
    }
}
